/*
 * pt-globo-fallback.js — Protool
 * Safety net for the Globo Smart Product Filter app.
 *
 * Why: Globo renders filters and product cards from its own server
 * (filter-eu9.globo.io). While it loads, Globo's CSS hides the products
 * (.spf-filter-loading #gf-products > * { visibility:hidden }). If that
 * server takes longer than 15s, Globo aborts the request and never removes
 * the loading class, so the collection page shows NO products and NO filters.
 *
 * What this does (only on pages with #gf-products):
 *   - after 5s still loading  -> shows a "Loading products and filters…" note
 *   - after 15.5s still loading -> removes the loading class so the products
 *     Shopify already rendered in the page become visible, and changes the
 *     note to "Filters are temporarily unavailable" with a Try again button.
 *   - if Globo finishes at any point -> the note is removed, nothing else changes.
 * It never touches Globo's own code or settings. Delete this file and its
 * script tag at the bottom of sections/vela-template-collection.liquid to remove it.
 */
(function () {
  'use strict';
  var NOTE_MS = 5000;
  var GIVE_UP_MS = 15500;

  function loadingEl() { return document.querySelector('.spf-filter-loading'); }

  function start() {
    var grid = document.getElementById('gf-products');
    if (!grid || !loadingEl()) return; // Globo not on this page, or already done

    var note = null;
    var finished = false;

    function css() {
      if (document.getElementById('pt-gf-fallback-css')) return;
      var s = document.createElement('style');
      s.id = 'pt-gf-fallback-css';
      s.textContent =
        '.pt-gf-note{font-family:Rubik,sans-serif;font-size:16px;line-height:1.5;color:#444;background:#f7f7f7;border:1px solid #e2e2e2;border-left:4px solid #cc1414;border-radius:3px;padding:12px 16px;margin:0 0 16px;display:flex;flex-wrap:wrap;align-items:center;gap:8px 16px;width:100%;box-sizing:border-box}' +
        '.pt-gf-note strong{color:#222;font-weight:500}' +
        '.pt-gf-note button{font-family:inherit;font-size:15px;font-weight:500;color:#fff;background:#cc1414;border:0;border-radius:3px;padding:8px 16px;cursor:pointer}' +
        '.pt-gf-note button:hover{background:#a81010}' +
        '.pt-gf-spin{width:16px;height:16px;border:2px solid #ddd;border-top-color:#cc1414;border-radius:50%;display:inline-block;animation:ptgfspin .8s linear infinite;flex:0 0 auto}' +
        '@keyframes ptgfspin{to{transform:rotate(360deg)}}';
      document.head.appendChild(s);
    }

    function showNote(html) {
      css();
      if (!note) {
        note = document.createElement('div');
        note.className = 'pt-gf-note';
        note.setAttribute('role', 'status');
        note.setAttribute('aria-live', 'polite');
        grid.parentNode.insertBefore(note, grid);
      }
      note.innerHTML = html;
    }

    function done() {
      if (finished) return;
      finished = true;
      var fb = document.querySelector('.pt-gf-fallback');
      if (fb) fb.classList.remove('pt-gf-fallback');
      if (note && note.parentNode) note.parentNode.removeChild(note);
      note = null;
      obs.disconnect();
    }

    // Globo signals success by removing its loading class (before we give up)
    // or by re-rendering the product grid (after we give up).
    var gaveUp = false;
    var obs = new MutationObserver(function () {
      if (!gaveUp && !loadingEl()) done();
    });
    obs.observe(document.documentElement, { attributes: true, subtree: true, attributeFilter: ['class'] });
    var gridObs = new MutationObserver(function () { if (gaveUp) { done(); gridObs.disconnect(); } });
    gridObs.observe(grid, { childList: true });

    setTimeout(function () {
      if (finished || !loadingEl()) return;
      showNote('<span class="pt-gf-spin" aria-hidden="true"></span><span>Loading products and filters&hellip;</span>');
    }, NOTE_MS);

    setTimeout(function () {
      var el = loadingEl();
      if (finished || !el) return;
      gaveUp = true;
      el.classList.remove('spf-filter-loading');
      el.classList.add('pt-gf-fallback');
      showNote('<span><strong>Product filters are temporarily unavailable.</strong> Showing products without filters.</span><button type="button">Try again</button>');
      var b = note.querySelector('button');
      if (b) b.addEventListener('click', function () { window.location.reload(); });
      // If Globo recovers late (grid replaced or filters drawn), drop the note.
      var poll = setInterval(function () {
        var fc = document.querySelector('#gf-tree .gf-filter-contents');
        if (finished || !document.contains(grid) || (fc && fc.children.length)) { clearInterval(poll); done(); }
      }, 1000);
      setTimeout(function () { clearInterval(poll); }, 60000);
      if (window.console) console.warn('[Protool] Globo filter did not load within ' + GIVE_UP_MS + 'ms — showing server-rendered products.');
    }, GIVE_UP_MS);
  }

  var started = false;
  function boot() {
    if (started) return;
    if (document.getElementById('gf-products') && loadingEl()) { started = true; start(); }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  // Globo may add its loading class a moment after the DOM is ready.
  setTimeout(boot, 1500);
})();
